import { Component, ViewEncapsulation, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { DisplayAuthService } from '../../services/display-auth.service';
import { NavigationService } from '../../services/navigation.service';
import { StorageService } from '../../services/storage.service';
import { MaintenanceCredentialsStorageDirective } from '../directives/maintenance-credentials-storage.directive';
import { MaintenanceConfirmableActionComponent } from './maintenance-confirmable-action/maintenance-confirmable-action.component';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    encapsulation: ViewEncapsulation.None,
  imports: [SharedModule, MaintenanceConfirmableActionComponent, MaintenanceCredentialsStorageDirective, TranslatePipe]
})
export class MaintenanceComponent {

  // TODO Uncomment when appropriate, for now we display this action in every environment.
  protected readonly isNonProd = true; // !environment.production;
  protected readonly credentialsAction?: 'store' | 'restore';

  private readonly storageService = inject(StorageService);
  private readonly navigationService = inject(NavigationService);

  constructor() {
    const storageService = this.storageService;
    const displayAuthService = inject(DisplayAuthService);

    if (this.isNonProd) {
      this.credentialsAction = MaintenanceCredentialsStorageDirective.getPossibleAction(!!storageService.data.devAuthSnapshot, displayAuthService.authStatus);
    }
  }

  protected onResetAllClick(): void {
    this.storageService.clearAll(true);
    this.onGoBackClick();
  }

  protected onGoBackClick(): void {
    this.navigationService.navigateByUrl(this.navigationService.initializationUrl);
  }

}
